var map = {
	"./blue.svg": 36245,
	"./cps.svg": 74255,
	"./green.svg": 30291,
	"./green_strike_through.svg": 99137,
	"./grey.svg": 68490,
	"./na.svg": 64057,
	"./no.svg": 21436,
	"./orange.svg": 65856,
	"./orange_exclamation_mark.svg": 81745,
	"./orange_stop.svg": 89949,
	"./pf.svg": 82766,
	"./pink.svg": 21326,
	"./red.svg": 10582,
	"./sc.svg": 69074,
	"./sh.svg": 75799,
	"./sib.svg": 17406,
	"./tmp.svg": 97395,
	"./va.svg": 6406,
	"./yellow.svg": 81272,
	"./yellow_strike_through.svg": 61761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70236;